import React from 'react';

import ProgressBar, {
  Props as ProgressBarProps
} from '@smart-tv/components/progress-bar/progress-bar';

import useInterval from '@smart-tv/hooks/use-interval';

import getProgress from '@smart-tv/utils/date/get-progress';

const DEFAULT_UPDATE_INTERVAL = 10000;

export interface Props extends Omit<ProgressBarProps, 'value'> {
  startTime: Date;
  endTime: Date;
  updateInterval?: number;
}

export const LiveTvProgressBar: React.FC<Props> = (props: Props) => {
  const { startTime, endTime, updateInterval = DEFAULT_UPDATE_INTERVAL, ...rest } = props;

  const [progress, setProgress] = React.useState(
    getProgress(new Date(), { start: startTime, end: endTime })
  );

  useInterval(
    () => setProgress(getProgress(new Date(), { start: startTime, end: endTime })),
    updateInterval
  );

  return <ProgressBar {...rest} value={progress} />;
};

export default React.memo(LiveTvProgressBar);
